import common from './common'

export default {
  ...common.button,
  color: `white`,
  '::after': {
    ...common.button['::after'],
    bg: `#2A205E`,
    borderColor: `#2A205E`
  }
}
